import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ny7c7awd6p: FaireBrandEntity = {
  token: "b_ny7c7awd6p",
  type: "brand",
  name: "UPSCALE FREEZE",
  avatarUrl:
    "https://cdn.faire.com/fastly/1df61dc7a7270a5fb8da86f9fd58bc13d98afc02835beb0368b3759eb6a9a1f8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d291513ea2cac154e22d96fc527c2711603b4ca7e17e5f567197cde1b19b2ed.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1df61dc7a7270a5fb8da86f9fd58bc13d98afc02835beb0368b3759eb6a9a1f8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d291513ea2cac154e22d96fc527c2711603b4ca7e17e5f567197cde1b19b2ed.png",
  location: "laveen, AZ, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 166,
  isInsider: true,
  description:
    "**********************WE DO NOT CANCEL ORDERS, PRE ORDERS OR REGULAR ORDERS AS THIS STRONGLY AFFECTS OUR STORE ANALYTICS***************\nAll chocolate orders are shipped with ice packs during the hot summer months with priority shipping. \nPlease track your packages, as we are not responsible for melted chocolate once in transit.\n\nAll chocolate & squishys toys orders are shipped via Priority Mail for faster & safer delivery.\n\nEverything we wholesale is also sold in our own 50+ boutique spaces — what you see here are our best sellers.\n\nWe are 100% licensed and fully compliant, operating from an FDA-certified commercial kitchen, with all required licenses, permits, bonds, and insurances in place.\n\n💙 Inspired & guided by our son in heaven, Roy Perfecto Galvan Jr. (11/26/2003 – 11/7/2021). Forever 17. 💙",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:19.664Z",
    importedBy: "entity-db-cli",
  },
};
